import type { FC, InputHTMLAttributes } from 'react';

import { cn } from '@/utils/cn.util';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean;
}

const Input: FC<InputProps> = ({ hasError = false, className, ...rest }) => (
  <input
    className={cn(
      'h-10 w-full rounded-md border bg-white px-3 text-sm transition-colors placeholder:text-[var(--color-ink-soft)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:bg-[var(--color-surface-muted)] disabled:text-[var(--color-ink-soft)]',
      hasError ? 'border-[var(--color-danger)]' : 'border-[var(--color-divider)]',
      className,
    )}
    {...rest}
  />
);

export default Input;
